import React from "react";
import { Grid, Typography } from "@mui/material";
import DetailRow from "../../pages/common-features/DetailRow";
import { useSelector } from "react-redux";
import { RootState } from "../../services/redux/store";

interface LoanDetailsTabProps {
  loanDetails: any[];
  isMobile: boolean;
}

const LoanDetailsTab: React.FC<LoanDetailsTabProps> = ({
  loanDetails,
  isMobile,
}) => {
  const { fetchUserApplicationData } = useSelector(
    (state: RootState) => state.stepper
  );

  // Helper to map fields from the vertical step to the required format
  function mapLoanDetailsFromVerticalStep(verticalStep: any) {
    if (!verticalStep || !verticalStep?.fields) return [];
    return verticalStep?.fields
      .filter(
        (fieldObj: any) =>
          Object.keys(fieldObj)[0] === "LoanDetailsLoanAmount" ||
          Object.keys(fieldObj)[0] === "collateral" ||
          Object.keys(fieldObj)[0] === "collateralType" ||
          Object.keys(fieldObj)[0] === "collateralAmount"
      )
      .map((fieldObj: any) => {
        const name = Object.keys(fieldObj)?.[0];
        const value = fieldObj?.[name];
        const label =
          name === "LoanDetailsLoanAmount"
            ? "Loan Amount"
            : name === "collateralType"
            ? "Collateral Type"
            : name === "collateralAmount"
            ? "Collateral Amount"
            : name.charAt(0).toUpperCase() + name.slice(1);
        return {
          label,
          name,
          value,
        };
      });
  }

  let loanDetailsToShow = loanDetails;

  if (
    fetchUserApplicationData &&
    !fetchUserApplicationData?.partnerStartedJourney
  ) {
    const applicantLoanStep = fetchUserApplicationData?.horizontalSteps?.find(
      (h: any) => h.horizontalStepName === "Applicant & Loan Details"
    );
    const loanDetailsStep = applicantLoanStep?.verticalSteps?.find(
      (v: any) => v.verticalStepName === "Co-Applicant Details"
    );
    if (loanDetailsStep) {
      loanDetailsToShow = mapLoanDetailsFromVerticalStep(loanDetailsStep);
    }
  }

  if (!loanDetailsToShow || loanDetailsToShow.length === 0) {
    return (
      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary">
          No details available.
        </Typography>
      </Grid>
    );
  }

  return (
    <>
      {loanDetailsToShow?.map((field: any, subIndex: number) => {
        const isCurrencyField =
          field?.label?.toLowerCase().includes("amount") ||
          field?.name?.toLowerCase().includes("amount");

        let updatedValue = field?.value ?? "";
        if (isCurrencyField && updatedValue !== "" && !isNaN(Number(String(updatedValue).replace(/,/g, "")))) {
          const numericValue = Number(String(updatedValue).replace(/,/g, ""));
          updatedValue = new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
            .format(numericValue)
            .replace("₹", "₹\u00A0");
        }

        return (
          <Grid item xs={12} sm={6} md={3} key={subIndex}>
            <DetailRow
              item={{
                label: field?.label ?? "",
                value: updatedValue,
                isVerified: false,
              }}
            />
          </Grid>
        );
      })}
    </>
  );
};

export default LoanDetailsTab;
